import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
//import QRCode from "qrcode.react";
import { QRCodeSVG } from "qrcode.react";
import axiosInstance from "./axiosInstance";

const Table = () => {
  const navigate = useNavigate(); 
   const [orderType, setOrderType] = useState("take-away"); 
  const [tablesData, setTablesData] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState("");
  const [selectedTable, setSelectedTable] = useState(null);
  const [show, setShow] = useState(false);
const [countAvilable, setCountAvilable] = useState(0);
const [countOccupaid, setCountOccupaid] = useState(0);
const [countReserved, setCountReserved] = useState(0);
const [orderId, setOrderId] = useState(null);
const [bgColor, setBgColor] = useState("white");
const [selectedTables, setSelectedTables] = useState(() => {
  // Load from sessionStorage on first render
  const saved = sessionStorage.getItem("selectedTables");
  return saved ? JSON.parse(saved) : [];
});
const [totalChairs, setTotalChairs] = useState(0);
const [patrons, setPatrons] = useState(0);
const [showPatronModal, setShowPatronModal] = useState(false);
const [pendingTable, setPendingTable] = useState(null); 
  // ✅ First test with static JSON
useEffect(() => {
  const fetchTables = () => {
    fetch("http://103.235.105.54/admin/api/tables", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        branch_id: sessionStorage.getItem("branch_id"),
        company_id: sessionStorage.getItem("company_id"),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched data:", data);

        if (data.status === true && Array.isArray(data.data)) {
          setTablesData(data.data);

          if (data.data.length > 0) {
            setSelectedFloor(data.data[0].floor);
          }

          // counts
          const availableCount = data.data.filter(
            (table) => table.availability_status === 1
          ).length;
          const occupiedCount = data.data.filter(
            (table) => table.availability_status === 2
          ).length;
          const reservedCount = data.data.filter(
            (table) => table.availability_status === 3
          ).length;

          setCountAvilable(availableCount);
          setCountOccupaid(occupiedCount);
          setCountReserved(reservedCount);
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  };

  fetchTables(); // fetch immediately when page loads
  const interval = setInterval(fetchTables, 10000); // fetch every 10 sec

  return () => clearInterval(interval); // cleanup on unmount
}, []);


  useEffect(() => {
    const savedType = sessionStorage.getItem("orderType");
    if (savedType) {
      setOrderType(savedType);
    }
  }, []);

useEffect(() => {
  if((selectedTables) && selectedTables.length > 0 )
    { setOrderType("dine-in");
    sessionStorage.setItem("orderType", "dine-in");
    }
   
 }, [selectedTables]);
useEffect(() => {
  const savedPatrons = sessionStorage.getItem("patrons");
    const savedChairs = sessionStorage.getItem("totalChairs");
  if (savedChairs) setTotalChairs(parseInt(savedChairs));
  if (savedPatrons) {
    setPatrons(parseInt(savedPatrons));
  }
}, []);
useEffect(() => {
  if (patrons > 0) {
    sessionStorage.setItem("patrons", patrons);
  }
}, [patrons]);
//   useEffect(() => {
//   if(totalChairs > 0 )
//     alert(totalChairs+"...."+patrons);
//       // {navigate("/item");} 
    
// }, [totalChairs,patrons]);

  // Handle selection
  const handleSelect = (type) => {
    setOrderType(type);
    sessionStorage.setItem("orderType", type);

    if (type === "dine-in") {
      navigate("/table");
    } else if (type === "take-away") {
      navigate("/item");
    }
  };
  const floors = [...new Set(tablesData.map((t) => t.floor))];
  const tables = tablesData.filter((t) => t.floor === selectedFloor);
  sessionStorage.setItem("tables", JSON.stringify(tables)); 

  const handleTableClick = (table) => {
    if (table.availability_status === 1) {
      setSelectedTable(table);
      setShow(true);
    }
  };
 const getStatusClass = (status) => {
    if (status === 1) return "table-available";
    if (status === 2) return "table-occupied";
    if (status === 3) return "table-reserved";
    return "";
  };

  const getStatusBadge = (status) => {
    if (status === 1) return "status-available";
    if (status === 2) return "status-occupied";
    if (status === 3) return "status-reserved";
    return "";
  };
const fetchOrder = async (tableId) => {
    try {
      if (!tableId) return;

      const res = await fetch(
        `http://103.235.105.54/admin/api/table-orders/${tableId}`
      );
      const data = await res.json();
      console.log("API Response:", data);

      if (data.status && data.data.length > 0) {
        const order = data.data[0];
        setOrderId(order.id);

        // Save full response to sessionStorage
        sessionStorage.setItem("orderResponse", JSON.stringify(data));
        navigate(`/order-update/${order.id}`);
      }
    } catch (err) {
      console.error("Error fetching order:", err);
    }
  };
const handleTableSelect = (table) => {
  if (table.availability_status === 2) {
    fetchOrder(table.id);
    return;
  }
  if (table.availability_status === 3) {
    return;
  }

  if (patrons === 0) {
    setPendingTable(table);
    setShowPatronModal(true);
    return;
  }

  setSelectedTables((prevSelected) => {
    let updated;
    let newTotalChairs = totalChairs;

    if (prevSelected.includes(table.id)) {
      // Deselect → remove from array
      updated = prevSelected.filter((id) => id !== table.id);
      newTotalChairs = totalChairs - table.chair_capacity;
    } else {
      // Add table even if it exceeds patrons
      updated = [...prevSelected, table.id];
      newTotalChairs = totalChairs + table.chair_capacity;
    }

    // Update state + sessionStorage
    setTotalChairs(newTotalChairs);
    sessionStorage.setItem("selectedTables", JSON.stringify(updated));
    sessionStorage.setItem("totalChairs", newTotalChairs);

    // Navigate if chairs >= patrons
    if (newTotalChairs >= patrons) {
      navigate("/item");
    }

    // If it exceeds patrons, you can show alert too
    if (!prevSelected.includes(table.id) && newTotalChairs > patrons) {
     // alert("⚠️ Total chairs count meet the number of patrons!");
    }

    return updated;
  });
};

    const handleCancelNow = () => {
      //navigate("/payment");

    sessionStorage.removeItem("selectedTables"); 
    sessionStorage.removeItem("orderType"); 
    sessionStorage.removeItem("patrons"); 
    sessionStorage.removeItem("totalChairs");
    setTotalChairs(0);
    setPatrons(0);
    setSelectedTables([]);
    setOrderType("take-away");

    };
  return (
    <main className="main-wrapper">
    <div className="main-content">

      
      {/* ✅ Floor Buttons */}
 <div className="restaurant-container">
          <div className="status-cards">
        <div className="status-card">
          <div className="status-card-content">
            <h6>Available Tables</h6>
            <div className="number status-number">{countAvilable || 0}</div>
          </div>
          <div className="status-indicator indicator-available"></div>
        </div>
        
        <div className="status-card">
          <div className="status-card-content">
            <h6>Occupied</h6>
            <div className="number status-number">{countOccupaid || 0}</div>
          </div>
          <div className="status-indicator indicator-occupied"></div>
        </div>
        
        <div className="status-card">
          <div className="status-card-content">
            <h6 >Reserved</h6>
            <div className="number status-number">{countReserved|| 0}</div>
          </div>
          <div className="status-indicator indicator-reserved"></div>
        </div>
      </div>
  {/* {selectedTables.length === 0 ? (<> */}
           <div className="d-flex justify-content-left gap-3 mb-4">
          <button
            className={`btn ${
              orderType === "dine-in" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => handleSelect("dine-in")}
          >
            Dine In
          </button>
          <button
            className={`btn ${
              orderType === "take-away" ? "btn-success" : "btn-outline-success"
            }`}
            onClick={() => handleSelect("take-away")}
          >
            Take Away
          </button>
          <button className="btn mt-3" onClick={handleCancelNow}>
  <i className="fas fa-undo-alt"></i>&nbsp; Reset
</button> 
        </div>
       
{/* </>):(<></>)} */}

      <div className="floor-tabs">
  {floors.map((floor) => (
    <button
      key={floor}
      onClick={() => setSelectedFloor(floor)}
      className={`floor-tab ${selectedFloor === floor ? "active" : ""}`}
    >
     Floor {floor}
    </button>
  ))}
</div>


      {/* ✅ Table Grid */}
    <div className="row">
  {/* Left Side - Tables */}
  <div className="col-md-12">
    <div className="tables-grid" >
      {tables.map((table) => (
        <div
          key={table.id}
          className={`table-card table-available ${getStatusClass(
            table.availability_status
          )}`}
      >
        <div  className="table-info" onClick={() => handleTableSelect(table)}  
         style={{
    backgroundColor: selectedTables.includes(table.id) ? "red" : "white"
  }} >
         <div className="table-icon relative inline-block" >
  <img
    src={`/assets/images/table/table_${table.chair_capacity}.png`}
    style={{ height: "50px", width: "auto" }}
  />

  {/* Badge in top-right corner */}
  <div className="seat-badge">
    {table.chair_capacity} <i className="fa fa-chair" aria-hidden="true"></i>
  </div>
</div>
<br /><br />
          <div className="table-info" >
            <div className="table-number">{table.table_code}</div>
            {/* <span
              className={`status-badge ${getStatusBadge(
                table.availability_status
              )}`}
            >
              {getStatusClass(table.availability_status)}
            </span> */}
          </div>
          </div>
        </div>
      ))}
    </div>
  </div>
  <div className="col-md-2" style={{display:"none"}}>
    <div className="card p-3">
      <h5>Selected Tables</h5>
      {selectedTables.length === 0 ? (
        <p>No tables selected</p>
      ) : (
        <ul>
          {tables
            .filter((t) => selectedTables.includes(t.id))
            .map((t) => (
              <li key={t.id}>{t.table_code}</li>
            ))}
        </ul>
      )}
    </div>
    <div className="col-md-4">
                  <button className="pay-btn mt-3" onClick={handleCancelNow}>
                    Cancel
                  </button>
                  </div> 
  </div>

  </div>




      {/* ✅ Modal */}
      {/* ✅ Table Details Modal */}
<Modal
  show={show}
  onHide={() => setShow(false)}
  centered
  size="sm"
  className="fade"
>
  <div className="modal-content">
    <div className="modal-header p-3 bg-primary">
      <h5 className="modal-title text-white">Table Details</h5>
      <button
        type="button"
        className="btn-close text-white"
        onClick={() => setShow(false)}
      ></button>
    </div>

    <div className="modal-body">
      {selectedTable && (
        <>
          <div className="table-detail-item">
            <span className="detail-label">Table Number</span>
            <span className="detail-value">{selectedTable.table_code}</span>
          </div>
          <div className="table-detail-item">
            <span className="detail-label">Seats</span>
            <span className="detail-value">{selectedTable.chair_capacity}</span>
          </div>
          <div className="table-detail-item">
            <span className="detail-label">Status</span>
            <span className="status-badge">
              {selectedTable.status || "Available"}
            </span>
          </div>
          <div className="table-detail-item">
            <span className="detail-label">Floor</span>
            <span className="detail-value">{selectedTable.floor}</span>
          </div>

          {/* QR Code */}
          <div className="text-center mt-3">
            <QRCodeSVG value={selectedTable.table_code} size={160} />
          </div>
        </>
      )}
    </div>

    {/* <div className="modal-footer p-1">
      <a onClick={handleMenuNavigation} type="button" className="btn btn-success">
        Go to Menu
      </a>
    </div> */}
  </div>
</Modal>

      </div>
      </div>
      <Modal show={showPatronModal} onHide={() => setShowPatronModal(false)} centered  dialogClassName="custom-modal-width">
  <div className="modal-header">
    <h7 className="modal-title">Enter Number of Patrons</h7>
    <button type="button" className="btn-close" onClick={() => setShowPatronModal(false)}></button>
  </div>
  <div className="modal-body">
    <input
      type="number"
      min="1"
      className="form-control"
      placeholder="Enter number of patrons"
      onChange={(e) => setPatrons(Number(e.target.value))}
    />
  </div>
  <div className="modal-footer">
    <button
      className="btn btn-primary"
      onClick={() => {
        if (patrons > 0) {
          // After patrons set, select the pending table
          setSelectedTables((prevSelected) => {
            let updated;
            if (prevSelected.includes(pendingTable.id)) {
              updated = prevSelected.filter((id) => id !== pendingTable.id);
            } else {
              updated = [...prevSelected, pendingTable.id];
                setTotalChairs(pendingTable.chair_capacity);
            }
            sessionStorage.setItem("selectedTables", JSON.stringify(updated));
            return updated;
          });
          setPendingTable(null);
          setShowPatronModal(false);
          if (patrons>0 && patrons <= pendingTable.chair_capacity) {
            navigate("/item");
          }
        }
      }}
    >
      Save
    </button>
  </div>
</Modal>

    </main>
  );
};

export default Table;
